module.exports = __webpack_public_path__ + "assets/img/Logistics.0d05ce0b.svg";